/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const SaveDirectAccessModal = () => {
  const location = useLocation();

  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation

  const [accessTitle, setaccessTitle] = useState("");
  const [accessDetails, setaccessDetails] = useState("");
  const [accessModule, setaccessModule] = useState("");
  const [accessUrl, setaccessUrl] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  /* hook for validation */
  const [validation, setValidation] = useState({
    nameWarning: false,
    urlWarning: false,
  });

  /* function to validate form */
  const validationHandler = () => {
    let isValid = true;

    if (accessTitle === "") {
      setValidation((prevState) => ({ ...prevState, nameWarning: true }));
      isValid = false;
    }

    if (accessUrl === "") {
      setValidation((prevState) => ({ ...prevState, urlWarning: true }));
      isValid = false;
    }

    return isValid;
  };

  //function for saving access
  const saveAccessHandler = async () => {
    if (validationHandler()) {
      seterrorMessage("");
      setIsSaving(true);
      try {
        let accessData = {
          moduleslug: accessModule,
          title: accessTitle,
          description: accessDetails,
          accessurl: accessUrl,
        };

        // console.log(accessData);

        let requestUrl = url.API_BASE_URL;

        let response = {};

        requestUrl += url.API_ADD_DIRECT_ACCESS + `?token=${token}`;

        response = await postData(requestUrl, accessData);

        console.log(response);

        setIsSaving(false);

        if (response.status) {
          resetHandler();

          // close the modal

          let currentModal = document.querySelector("#saveDirectAccess");
          let modal = bootstrap.Modal.getInstance(currentModal);
          modal.hide();
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
      seterrorMessage(t("Please fill up required fields"));
    }
  };

  const resetHandler = () => {
    seterrorMessage("");
    setaccessTitle("");
    setaccessDetails("");
    setaccessModule(location.pathname.slice(1).replace(/\//g, "_"));
    setaccessUrl(location.pathname);

    setValidation({
      nameWarning: false,
      urlWarning: false,
    });
  };

  useEffect(() => {
    setaccessModule(location.pathname.slice(1).replace(/\//g, "_"));
    setaccessUrl(location.pathname);
  }, []);

  return (
    <div
      className="modal fade"
      id="saveDirectAccess"
      tabIndex="-1"
      aria-labelledby="saveDirectAccess"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary icon-md">
                  bookmark
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-lg text-white mb-0"
                  id="saveDirectAccess"
                >
                  {t("Bookmark to Direct Access")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Configure your direct access details")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form onSubmit={(e) => e.preventDefault()}>
                {/* ----- user select section start ----- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="urlname"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Add Title")} <span className="text-danger">*</span>
                  </label>
                  <input
                    className={`form-control fs-sm shadow-none ${
                      validation.nameWarning
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    placeholder={t("Enter Access Name")}
                    value={accessTitle}
                    onChange={(e) => {
                      setaccessTitle(e.target.value);
                      setValidation((prevState) => ({
                        ...prevState,
                        nameWarning: false,
                      }));
                      seterrorMessage("");
                    }}
                  />
                  {validation.nameWarning && (
                    <div className="invalid-feedback d-block">
                      {t("Please enter title")}!
                    </div>
                  )}
                </div>
                {/* ----- user select section end ----- */}

                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="slugID"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Details")}
                  </label>
                  <textarea
                    name="details"
                    id="details"
                    cols="30"
                    rows="3"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder={t("Details")}
                    value={accessDetails}
                    onChange={(e) => setaccessDetails(e.target.value)}
                  ></textarea>
                </div>

                {/* ----- url section start ----- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="role"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Bookmark Url")} <span className="text-danger">*</span>
                  </label>

                  <p className="form-control fs-sm shadow-none border border-gray-300">
                    {accessUrl}
                  </p>

                  {validation.urlWarning && (
                    <div className="invalid-feedback d-block">
                      {t("Please enter bookmark url")}!
                    </div>
                  )}
                </div>
                {/* ----- url section end ----- */}

                {/* ----- button section start ----- */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-4">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={saveAccessHandler}
                    disabled={isSaving ? true : false}
                    style={{
                      cursor: isSaving ? "not-allowed" : "pointer",
                    }}
                  >
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Bookmark")}
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                </div>
                {/* ----- button section end ----- */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveDirectAccessModal;
